import React from 'react';
import Container from './Container';
import Text from './Text';
import Image from './Image';
import Date from './Date';

export default ({ purchase }) => (
  <Container>
    <Image src={purchase.image} />
    <Text>{purchase.title}</Text>
    <Date>{purchase.updated_at}</Date>
  </Container>
);
